import { useEffect, useState } from 'react';
import { Config, FestiveMode } from '../../../services';
import { Halloween } from './Halloween';
import { Snowflakes } from './Snowflakes';

interface FestiveModeArgs {
  config?: Config;
}

export const useFestiveMode = ({ config }: FestiveModeArgs) => {
  const [festiveModeComponent, setFestiveModeComponent] = useState<JSX.Element | null>(null);

  useEffect(() => {
    if (!config) {
      return;
    }

    const { mode } = config.elements.festiveMode;

    if (mode === FestiveMode.SNOWFLAKES) {
      setFestiveModeComponent(<Snowflakes />);
      return;
    }

    if (mode === FestiveMode.HALLOWEEN) {
      setFestiveModeComponent(<Halloween />);
    }
  }, [config]);

  return { festiveModeComponent };
};
